import {FIELD_LIST_INTRO_ABOUT_US} from "../../utils/input-field-list-static-page";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAboutUsIntroDetail} from "../../reducers/about-us.reducer";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const Intro = () => {
    const dispatch = useDispatch()
    const {introDetail, aboutUsErrorMessage} = useSelector(state => state.aboutUsReducer)
    let fieldList = FIELD_LIST_INTRO_ABOUT_US
    let showIntro = {
        label: 'Intro',
        key: 'show_intro',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAboutUsIntroDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        console.log(introDetail)
        // submit form
    }

    return (
        <FormGeneralComponent
            data={introDetail}
            switchToggleField={showIntro}
            fieldList={fieldList}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'col space-y-4'}
            itemInputClassName={{
                key: 'description',
                value: ['w-full', 'w-1/2']
            }}
            errorMessage={aboutUsErrorMessage}
        />
    )
}

export default Intro